import { Box, Text } from '@cmpsr/components';
import { forwardRef } from 'react';
import { TestSpecsType } from '../your-testing-plan/types';
import TestFooter from './components/test-footer/test-footer';
import TestItem from './components/test-item/test-item';

const TestSpecs = forwardRef<HTMLDivElement, TestSpecsType>(
  ({ testSensitivity, testSpecificity, positivePredictiveValue, negativePredictiveValue, id }, ref) => {
    return (
      <Box
        ref={ref}
        as="section"
        p={5}
        border="1px solid"
        borderColor="ui-element-divider"
        borderRadius="radii-3"
        bgColor="background-light"
        id={id ?? 'value'}
      >
        <Text
          variant={{ base: 'text-body-medium', lg: 'text-body-display-XS' }}
          mb={4}
          fontWeight={600}
          letterSpacing={0}
        >
          Predictive Value
        </Text>

        <TestItem
          title="Sensitivity"
          description="If you have a disease, this is the likelihood that the test would detect it (i.e. 1 - false negative rate)"
          value={testSensitivity}
        />
        <TestItem
          title="Specificity"
          description="If you do NOT have a disease, this is the likelihood that the test would return a negative result (i.e. 1 - false positive rate)"
          value={testSpecificity}
        />
        <TestItem
          title="Positive Predictive Value"
          description="If you receive a positive result on a test, this is the likelihood that you actually have the disease."
          value={positivePredictiveValue}
        />
        <TestItem
          title="Negative Predictive Value"
          description="If you receive a negative result on a test, this is the level of certainty that you do NOT have the disease. "
          value={negativePredictiveValue}
        />
        <TestFooter />
      </Box>
    );
  }
);

TestSpecs.displayName = 'TestSpecs';

export default TestSpecs;
